import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { DcDetail, DcDetailModel } from '../../common/model/header';
import { CacheResolverService } from '../../core/cache/cache-resolver.service';
import { HrmGroup } from '../../core/constants/app.constant';
import { AuthService } from '../../core/services/auth.service';
import { EventsService } from '../../modules/events/events.service';
import { masterApiUrl } from '../../modules/events/serviceUrl.constant';
import { HoldService } from '../service/hold.service';
import { TokenService } from 'src/app/shared/utils/token.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  accounts = new FormControl();
  mobile = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredAccountsOptions!: Observable<string[]>;
  filteredMobileOptions!: Observable<string[]>;
  headerMsg: Array<Object> = [];
  splashMessageFlag: Boolean = false;

  public dc: DcDetail[];
  public selectedDC;
  public defaultDC;
  public userFlag;
  public userRole: string;
  public dcRole !: FormGroup;
  public readonly HrmGroup = HrmGroup;
  public readonly ngUnsubscribe = new Subject<void>();


  constructor(
    private eventService: EventsService,
    private readonly cacheService: CacheResolverService,
    private authService: AuthService,
    private holdService: HoldService,
    private route: Router,
    private dialogRef: MatDialog,
    private tokenService: TokenService,
  ) { }

  search: string = ''
  hidden = true;
  userDetails: any;

  splashData: Object = {
    column: '',
    direction: '',
    pageNo: 1,
    pageSize: 0,
    flashMessageQueryModel: {
      startDate: null,
      expiryDate: null,
      active: true,
      displayType: null,
      messageSearch: null,
      isActive: true,
      notification: true
    }
  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }

  ngOnInit(): void {
    this.dcRole = new FormGroup({
      'dcRole': new FormControl()
    });
    this.userDetails = this.cacheService.get('user-auth');
    this.userRole = this.cacheService.get('userRole');

    this.getSplashData();


    this.holdService.isActive().toPromise().then(value => {
      this.userFlag = value;
    });

    this.getDCAllocated().toPromise().then(dcList => {
      const dcIdEmail = this.cacheService.get('dcId');
      const numberValue: number = Number(dcIdEmail);
      if (numberValue) {
        dcList['distributionCentreDetails'] = this.moveToFirstPosition(dcList.distributionCentreDetails, numberValue);
        this.cacheService.remove('dcId');
      }

      this.defaultDC = dcList['distributionCentreDetails'][0]?.distributionCentreId;
      this.dcRole.get('dcRole').setValue(this.defaultDC);
      if (!this.defaultDC && dcList['distributionCentreDetails'].length === 0) {
        return
      };
      this.holdService.dcSelecetd.next([this.defaultDC,
      dcList['distributionCentreDetails'][0]?.plantCode,
      dcList['distributionCentreDetails'][0]?.distributionCentreName]);
    });
  }


  ngAfterViewInit(): void {
    if (this.dc) {
      this.defaultDC = this.dc['distributionCentreDetails'][0].distributionCentreId;
    }
  }

  public moveToFirstPosition(arr: any[], distributionCentreId: number): any[] {
    const index = arr.findIndex(dc => dc.distributionCentreId === distributionCentreId);
    if (index > -1) {
      const element = arr[index];
      const filterArray = arr.filter(dc => dc.distributionCentreId !== distributionCentreId);
      return [element, ...filterArray];
    }
    return arr;
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  getSplashData() {
    let auth = this.cacheService.get('user-auth');
    if (auth) {
      this.holdService.splashmessage.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        this.eventService.postApiRequest("masterdata", masterApiUrl.getSplashMessage, this.splashData).
          toPromise().then(res => {
            this.splashMessageFlag = true;
            this.headerMsg = [];
            for (let r of res.listFlashMessage) {
              if (r.displayType !== 'External') {
                this.headerMsg.push(r);
              }
            }
          });
      });
   }
  }

  public getDCAllocated(): Observable<any> {
    let userId = this.userDetails.detail.iiqUserId;
    return this.eventService.getUserDCAllocated(userId).pipe(
      takeUntil(this.ngUnsubscribe),
      tap((dcList: DcDetailModel) => {
        this.dc = dcList['distributionCentreDetails'];
        this.dc = this.sortDcNameDropdownValues(this.dc);
      })

    )

  }


  sortDcNameDropdownValues(dcCodeList: any[]): any[] {
    return dcCodeList.sort((a, b) => {
      const isDcCodeA = /^\d+$/.test(a.plantCode);
      const isDcCodeB = /^\d+$/.test(b.plantCode);
      if (isDcCodeA && isDcCodeB) {
        return Number(b) - Number(a);
      } else if (isDcCodeA) {
        return -1;
      } else if (isDcCodeB) {
        return 1;
      } else {
        return a.plantCode.localeCompare(b.plantCode);
      }
    });
  }

  public async selected(dcValue: string, dcCode: string, dcName: string): Promise<void> {
    this.holdService.dcSelecetd.next([dcValue, dcCode, dcName]);
    this.route.navigate(['/dashboard']);
  }

  logout() {
    this.dialogRef.closeAll();
    this.authService.signOut();
  }
}
